import React from 'react';
import { Sprout } from 'lucide-react';
import { companyLabel, fmtDate } from './c360Shared';

export const OrigemCard = ({ origem }) => {
  if (!origem?.desde) return null;
  const pc = origem.primeiro_contrato;
  return (
    <div className="rounded-2xl border border-[#4DD4E8]/40 bg-[#4DD4E8]/5 p-4 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm" data-testid="c360-origem">
      <span className="inline-flex items-center gap-2 font-bold font-[Outfit] text-[#2D3E6F]"><Sprout className="w-4 h-4 text-[#4DD4E8]" />Origem do cliente</span>
      <span data-testid="c360-origem-desde">No CRM desde <b>{fmtDate(origem.desde)}</b></span>
      {origem.via && <span data-testid="c360-origem-via">Veio por <b>{origem.via}</b></span>}
      {origem.por && <span data-testid="c360-origem-por">Trazido por <b>{origem.por}</b></span>}
      {origem.angariador && origem.angariador !== origem.por && <span>Angariador <b>{origem.angariador}</b></span>}
      {pc && (
        <span data-testid="c360-origem-primeiro">
          1º contrato: <b>{companyLabel(pc.company)}</b>{pc.de ? ` (vinha de ${companyLabel(pc.de)})` : ''} · {fmtDate(pc.data)}
        </span>
      )}
    </div>
  );
};
